import { data } from '../../svg/Inbox/data';
import { makeIcon } from '../makeIcon';

export const Inbox = makeIcon(data, 'inbox', 'Inbox');

export default Inbox;
